import { render } from "./Feedback.vue?vue&type=template&id=ccdaf0d0&scoped=true&ts=true&lang=pug"
import script from "./Feedback.vue?vue&type=script&lang=ts"
export * from "./Feedback.vue?vue&type=script&lang=ts"

import "./Feedback.vue?vue&type=style&index=0&id=ccdaf0d0&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccdaf0d0"]])

export default __exports__